<template>
   <div class="card-info-box">
    <div class="card-info">
      <img src="../../assets/image/card-icon.svg" alt="" />
      <div class="name-info">
        <div class="card-name">
          <div class="name-text">{{props.cardInfo?.cardOwner}}</div>
          <div class="card-type" :class="props.cardInfo?.cardChannel==='Visa' ? 'visa' : 'master-card'">{{props.cardInfo.cardChannel === 'Visa' ? 'VISA' : 'Master card' }}</div>
          <!-- <div v-if="cardType==='masterCard'" class="card-type master-card">Master card</div> -->
        </div>
        <!-- 4514 **** **** 6847 -->
        <div class="card-number">{{props.cardInfo?.cardNum?.replace(/(.{4})/g, '$1 ')}}</div>
      </div>
    </div>
    <div class="expired-box">
      <div class="expired-text valid-date">{{$t('design.creditCard.validDate') || "有效期至"}} {{ props.cardInfo?.expiryMonth + '/' + props.cardInfo?.expiryYear }}</div>
      <!-- 即将过期 -->
      <div v-if="props.cardInfo?.cardStatus==='timeoutSoon'" class="expiring-status">
        <xl-icon size="13" color="#FFA755"><Warning /></xl-icon>
        <span class="expired-text expiringSoon-tip">{{$t('design.creditCard.expiringSoonTip') || "即将过期"}}</span>
      </div>
      <!-- 已过期 -->
      <div v-if="props.cardInfo?.cardStatus==='timeout'">
        <xl-icon size="13" color="#E64C4C"><Warning /></xl-icon>
        <span class="expired-text expired-tip">{{$t('design.creditCard.expiredTip') || "已过期"}}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { XlIcon } from "@shining3d/ui-components";
import { XlPlus, Warning } from "@shining3d/icons-vue";
import { ref } from 'vue'
import { useLang } from '@shining3d/common-module/utils/lang.js';
const { $t } = useLang( '@shining3d/xl-design-order' );

const props = defineProps({
  cardInfo: {
    type: Object
  }
})
const cardType = ref( 'visa' );
const expiredType = ref( 'expiringSoon');
</script>

<style lang="scss" scoped>
.card-info-box {
  width: 428px;
  height: 76px;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: #f7f8fa;
  .card-info {
    display: flex;
  }
  .name-info {
    margin-left: 12px;
    .card-name {
      display: flex;
      align-items: center;
      .name-text {
        margin-right: 8px;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        color: #42526e;
      }
      .card-type {
        height: 16px;
        border-radius: 2px;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        padding: 0 6px;
        text-align: center;
        
      }
      .visa{
        background: #c3eedf;
        color: #0fbd81;
      }
      .master-card{
        background: #D6D8FA;
        color: #5E65EB;
      }
    }
    .card-number {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #42526e;
    }
  }
  .expired-box {
    max-width: 180px;
    .expired-text {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
    }
    .valid-date {
      color: #737e99;
      overflow: hidden;
      white-space: nowrap;
    }
    .expiring-status{
      display: flex;
      align-items: center;
    }
    .expiringSoon-tip {
      display: inline-block;
      margin-left: 4px;
      color: #ffa755;
      max-width: 155px;
      overflow-x: hidden;
    }
    .expired-tip{
        margin-left: 4px;
        color: #E64C4C;
    }
  }
}
</style>
